import styled from 'styled-components'

const StatValue = styled.p`
    color: #fafafa;
    font-weight: 900;
    font-size: 8rem;
    letter-spacing: 2px;
    margin: 0;
`

export default StatValue